import { Icon, Layout, Menu, message } from 'antd';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import I18N from 'src/services/I18NService';
import LoginService from 'src/services/LoginService';
import StorageService from 'src/services/StorageService';
import NotifyLayout from 'src/containers/NotifyLayout';
import WebSocketService from 'src/services/WebSocketService';
import { IStateCollection } from 'src/entity/StateEntity';
import { userLogout } from 'src/redux/actions/authCreator';
import { clearSessionData } from '../../redux/actions/index';

const { Header } = Layout;

interface IHeaderLayoutProps extends RouteComponentProps {
  dispatch: React.Dispatch<IStateCollection>;
}

class HeaderLayout extends React.Component<IHeaderLayoutProps> {
  constructor(props: IHeaderLayoutProps) {
    super(props);
  }

  logoutHandle = (e: any) => {
    e.preventDefault();
    LoginService.agentLogout()
      .then(() => {
        clearSessionData(this.props.dispatch);
        WebSocketService.disConnect();
        this.props.dispatch(userLogout());
        this.props.history.push('/');
      })
      .catch(error => {
        if (!!error.response) {
          message.error(JSON.stringify(error.response.data));
        } else {
          message.error(I18N.get('err_logout_failure'));
        }
      });
  };

  render() {
    let username = I18N.get('common_admin');
    const userObj = StorageService.getUserStorage();
    if (!!userObj) {
      username = userObj.username;
    }
    return (
      <Header className="header-box">
        <span className="header-title">{I18N.get('common_partner_title')}</span>
        <Menu theme="light" mode="horizontal" className="header-menu" selectable={false}>
          <Menu.Item key="notify">
            <NotifyLayout />
          </Menu.Item>
          <Menu.SubMenu
            title={
              <span className="header-user-icon">
                <Icon type="user" />
                <span>{username}</span>
              </span>
            }
          >
            <Menu.Item key="logout">
              <span onClick={this.logoutHandle}>
                <Icon type="poweroff" />
                {I18N.get('login_logout')}
              </span>
            </Menu.Item>
            {/* <Menu.Item key="logout" style={{ textAlign: 'center' }}>
                            <span onClick={this.logoutHandle}><Icon type="poweroff" />{i18n.get('login_logout')}</span>
                        </Menu.Item> */}
          </Menu.SubMenu>
        </Menu>
      </Header>
    );
  }
}

export default withRouter(HeaderLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/HeaderLayout.tsx